import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { Vacation } from '../types/vacation';
import { DataFetchError } from '../../utils/ErrorClass';

const useVacation = () => {
  const [vacations, setVacations] = useState<Vacation[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('vacation')
        .select('*')
        .gte('vacation_date', new Date().toISOString().split('T')[0]) // 現在の日付以降を取得

      if (error) {
        throw new DataFetchError(error.message);
      }

      setVacations(data as Vacation[]);
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { vacations, loading, error };
};

export default useVacation;
